// Drawers another page can ask the Numbers page to open on arrival, via
// navigate('/numbers', { state: { openDrawer } }). The Numbers page opens it
// itself once its data has loaded; callers never render the drawer.
export const NUMBERS_PAGE_DRAWER = {
    AVAILABLE_NUMBER_BLOCKS: 'availableNumberBlocks',
};
